// 班牌管理
const IpClassCardManage = () => import( /* webpackChunkName: "infoPublic" */ '@/pages/infoPublic/views/ipClassCardManage/IpClassCardManage.vue')
const AddCard = () => import( /* webpackChunkName: "infoPublic" */ '@/pages/infoPublic/views/ipClassCardManage/AddCard.vue')
const ScanList = () => import( /* webpackChunkName: "infoPublic" */ '@/pages/infoPublic/views/ipClassCardManage/ScanList.vue')
//班牌信发
//公共页
const ClassCardInfoSend = () => import( /* webpackChunkName: "infoPublic" */ '@/pages/infoPublic/views/classCardInfoSend/ClassCardInfoSend.vue')
//发布照片
const SendPic = () => import( /* webpackChunkName: "infoPublic" */ '@/pages/infoPublic/views/classCardInfoSend/SendPic.vue')
//发布视频
const SendVideo = () => import( /* webpackChunkName: "infoPublic" */ '@/pages/infoPublic/views/classCardInfoSend/SendVideo.vue')
//发布通知
const Notice = () => import( /* webpackChunkName: "infoPublic" */ '@/pages/infoPublic/views/classCardInfoSend/Notice.vue')
//任务记录
const PublishTake = () => import( /* webpackChunkName: "infoPublic" */ '@/pages/infoPublic/views/classCardInfoSend/PublishTake.vue')
//任务记录---详情页
const ContentDetail = () => import( /* webpackChunkName: "infoPublic" */ '@/pages/infoPublic/views/classCardInfoSend/ContentDetail.vue')



// 选择班牌
const SelectClassCard = () => import( /* webpackChunkName: "infoPublic" */ '@/pages/infoPublic/views/classCardInfoSend/SelectClassCard.vue')

// 选择班牌
const Already = () => import( /* webpackChunkName: "infoPublic" */ '@/pages/infoPublic/views/classCardInfoSend/Already.vue')

// 完成页
const OperationSuccessful = () => import( /* webpackChunkName: "infoPublic" */ '@/pages/infoPublic/views/classCardInfoSend/OperationSuccessful.vue')

const infoPublic = [
  {
    path: 'IpClassCardManage',
    name: 'IpClassCardManage',
    component: IpClassCardManage,
    children: [
      {
        path: 'AddCard',
        name: 'AddCard',
        component: AddCard,
      }
    ]
  },
  {
    path: 'ScanList',
    name: 'ScanList',
    component: ScanList,
  },
  {
    path: 'ClassCardInfoSend',
    name: 'ClassCardInfoSend',
    component: ClassCardInfoSend
  },
  {
    path: 'SendPic',
    name: 'SendPic',
    component: SendPic,
  },
  {
    path: 'SendVideo',
    name: 'SendVideo',
    component: SendVideo,
  },
  {
    path: 'SelectClassCard',
    name: 'SelectClassCard',
    component: SelectClassCard,
  },
  {
    path: 'Notice',
    name: 'Notice',
    component: Notice,
  },
  {
    path: 'PublishTake',
    name: 'PublishTake',
    component: PublishTake,
  },
  {
    path: 'ContentDetail',
    name: 'ContentDetail',
    component: ContentDetail,
  },
  {
    path: 'OperationSuccessful',
    name: 'OperationSuccessful',
    component: OperationSuccessful,
  },
  {
    path: 'Already',
    name: 'Already',
    component: Already,
  }
  
]
export default infoPublic
